import React from "react";

export default function LoanStatementView({ data }) {
  if (!data) return null;

  return (
    <>
      <br />

      {/* Header */}
      <div className="w-full text-left p-3 flex items-center gap-3 bg-[#5a6db3] ">
        <h2 className="text-lg font-semibold">Loan Statement Details</h2>
      </div>

      {/* Top Info Section */}
      <div className="border border-t-0 rounded-b-lg p-4 grid grid-cols-2 gap-6 bg-white shadow">
        {/* Borrower Info */}
        <div>
          <h3 className="font-semibold mb-2">Borrower Information</h3>
          <p><b>Account Holder:</b> {data.account_holder_name || "N/A"}</p>
          <p><b>Address:</b> {data.account_holder_address || "N/A"}</p>
          <p><b>Account Number:</b> {data.account_number || "N/A"}</p>
          <p><b>Bank Name:</b> {data.bank_name || "N/A"}</p>
          <p><b>Loan Type:</b> {data.loan_type || "N/A"}</p>
        </div>

        {/* Loan Summary */}
        <div>
          <h3 className="font-semibold mb-2">Loan Summary</h3>
          <p>
            <b>Original Loan Amount:</b>{" "}
            {data.currency} {data.original_loan_amount || "0"}
          </p>
          <p>
            <b>Opening Balance:</b>{" "}
            {data.currency} {data.opening_balance || "0"}
          </p>
          <p>
            <b>Closing Balance:</b>{" "}
            {data.currency} {data.closing_balance || "0"}
          </p>
          <p>
            <b>Annual Interest Rate:</b>{" "}
            {data.annual_interest_rate ?? "0"}%
          </p>
          <p>
            <b>Statement Period:</b>{" "}
            {data.statement_start_date || "-"} -{" "}
            {data.statement_end_date || "-"}
          </p>
        </div>
      </div>

      {/* Irregularities */}
      <div
        className="mt-4 p-3 border rounded-lg text-black"
        style={{ background: "aliceblue" }}
      >
        <b>Irregular Transactions:</b>{" "}
        {data.irregular_transaction_notes || "None"}
      </div>

      {/* Transactions */}
      <div className="border bg-white shadow mt-6">
        <h3 className="w-full text-left p-3 bg-[#5a6db3] ">
          Transactions
        </h3>

        <div className="overflow-x-auto">
          <table className="w-full border rounded-lg overflow-hidden">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-2 border">Date</th>
                <th className="px-4 py-2 border">Description</th>
                <th className="px-4 py-2 border">Type</th>
                <th className="px-4 py-2 border text-right">Payments In</th>
                <th className="px-4 py-2 border text-right">Payments Out</th>
                <th className="px-4 py-2 border text-right">Balance</th>
                <th className="px-4 py-2 border">Reference</th>
                <th className="px-4 py-2 border">Flag</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(data.transactions) && data.transactions.length ? (
                data.transactions.map((txn) => (
                  <tr key={txn.id} className="hover:bg-gray-50">
                    <td className="px-4 py-2 border">{txn.date}</td>
                    <td className="px-4 py-2 border">{txn.description}</td>
                    <td className="px-4 py-2 border">
                      {txn.transaction_type}
                    </td>

                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.payments_in_amount
                          ? "text-green-600"
                          : "text-gray-400"
                      }`}
                    >
                      {txn.payments_in_amount || ""}
                    </td>

                    <td
                      className={`px-4 py-2 text-right border ${
                        txn.payments_out_amount
                          ? "text-red-600"
                          : "text-gray-400"
                      }`}
                    >
                      {txn.payments_out_amount || ""}
                    </td>

                    <td className="px-4 py-2 text-right border font-semibold">
                      {txn.balance}
                    </td>

                    <td className="px-4 py-2 border">
                      {txn.reference_number}
                    </td>

                    <td className="px-4 py-2 border">
                      {txn.is_flagged ? (
                        <span className="text-red-600 font-semibold">
                          ⚠ {txn.flag_reason}
                        </span>
                      ) : (
                        <span className="text-gray-400">—</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center py-3 border">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
